export function resolveScorecardEnabled(override?: string): boolean {
  return override === 'true'
}

export function isScorecardEnabled(): boolean {
  return resolveScorecardEnabled(import.meta.env.VITE_SCORECARD_ENABLED)
}

export function resolveOgsmEnabled(override?: string): boolean {
  return override === 'true'
}

export function isOgsmEnabled(): boolean {
  return resolveOgsmEnabled(import.meta.env.VITE_OGSM_ENABLED)
}

export function resolvePortalOgsmEnabled(override?: string): boolean {
  return override === 'true'
}

/** The portal OGSM tab and level control; the tab also needs `ogsm:view:own`. */
export function isPortalOgsmEnabled(): boolean {
  return resolvePortalOgsmEnabled(import.meta.env.VITE_PORTAL_OGSM_ENABLED)
}

export function resolveScorecardManualAddHidden(override?: string): boolean {
  return override === 'true'
}

export function isScorecardManualAddHidden(): boolean {
  return resolveScorecardManualAddHidden(
    import.meta.env.VITE_SCORECARD_MANUAL_ADD_HIDDEN
  )
}
